<div id="attribute">
    <div class="index-head" fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="start center" class="heading-container">
            <h5 class="pincode-heading">Pincode Pricing</h5>
        </div>
        <button mat-dialog-close mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-divider></mat-divider>
    <form class="padding-10" [formGroup]="firstFormGroup" autocomplete="off">
        <div class="padding-10" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
            <mat-form-field appearance="outline" fxFlex>
                <mat-label>Pin Code</mat-label>
                <input numbersOnly [autocomplete]="'off'" trim="blur" matInput formControlName="pincode">
            </mat-form-field>
        </div>
        <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
            <button type="button" mat-raised-button (click)="close()">Cancel
            </button>
            <button  (click)="savePincodePricing()" mat-raised-button class="blue-button">
                Save
            </button>
        </div>
    </form>
</div>
